import { Injectable } from '@angular/core';

@Injectable()
export class AppAlertService {
	public alerts: any[] = [];
	private defaultAlerts: any[] = [];

	constructor() {}

	reset(): void {
		this.alerts = [];
	}

	close(dismissedAlert: any): void {
		this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
	}

	exampleAlert(): void {
		const tiempo = 30000;

		this.alerts.push({
			type: 'warning',
			msg: `Esta alerta se cierra en ${tiempo} milisegundos (${new Date().toLocaleTimeString()})`,
			timeout: tiempo,
		});
	}

	error(message, timeout = null): void {
		this.alerts.push({
			type: 'danger',
			msg: message,
			timeout: timeout,
		});
	}

	info(message, timeout = 15000): void {
		this.alerts.push({
			type: 'info',
			msg: message,
			timeout: timeout,
		});
	}

	success(message, timeout = 15000): void {
		this.alerts.push({
			type: 'success',
			msg: message,
			timeout: timeout,
		});
	}

	warning(message, timeout = 15000): void {
		this.alerts.push({
			type: 'warning',
			msg: message,
			timeout: timeout,
		});
	}

	login(message, timeout = 15000): void {
		this.alerts.push({
			type: 'danger',
			msg: message,
			timeout: timeout,
			linkLogin: true,
		});
	}

	withoutPermits(message, timeout = null): void {
		this.alerts.push({
			type: 'danger',
			msg: message,
			timeout: timeout,
			linkLogin: true,
		});
	}
}
